import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage, Program, ProgramWrite } from 'types';
import { client } from 'utils/api-client';

export default function useUpdateProgram(): UseMutationResult<
  AxiosResponse<Program>,
  AxiosError<ErrorMessage>,
  ProgramWrite
> {
  const queryClient = useQueryClient();

  const updateProgram = (payload: ProgramWrite): Promise<AxiosResponse<Program>> => {
    return client.put(`programs/${payload?.programId}/`, payload);
  };

  return useMutation(updateProgram, {
    onSuccess: () => {
      queryClient.invalidateQueries(['programs']);
    },
  });
}
